import React, { FC, useEffect, useRef } from "react"

import { PricingTableFeatureFragmentFragment, PricingTablePlanFragmentFragment } from "@graphqlTypes"

import { isClientSide } from "@utils"

import PricingTableFeature from "./PricingTableFeature/PricingTableFeature"

import { PricingTableFeaturesDIV } from "./PricingTableFeatures.styles"

const PricingTableFeatures: FC<{
  features?: Array<PricingTableFeatureFragmentFragment | null> | null,
  onIntersecting: () => void,
  plans?: Array<PricingTablePlanFragmentFragment | null> | null,
  title?: string | null,
}> = ({
  features,
  onIntersecting,
  plans,
  title,
}) => {
    if (!features || !plans) return null

    const ObserverRef = useRef<IntersectionObserver | null>(null)
    const ElRef = useRef<HTMLDivElement | null>(null)

    useEffect(() => {
      if (!isClientSide() || !ElRef.current) return

      const handleObserver: IntersectionObserverCallback = (entries) => {
        if (entries[0].isIntersecting) {
          onIntersecting()
        }
      }

      ObserverRef.current = new IntersectionObserver(handleObserver, {
        threshold: [0, 1],
        rootMargin: "0px 0px -95%",
      })

      ObserverRef.current.observe(ElRef.current)
    }, [])

    return (
      <PricingTableFeaturesDIV
        key={title}
        ref={ElRef}
      >
        <div className="container">
          <div className="category-header">
            <div className="grid">
              <div className="column column--1-4-L column--1-5-XL">
                {title && <h4 className="type--headline-semibold-L">{title}</h4>}
              </div>
              <div className="plans flex column column--4-13-L column--5-13-XL">
                {plans.map(plan => !plan ? null : (
                  <div className="plan flex-item--3" key={plan.name}>
                    <h6 className="type--headline-semibold-S">{plan.name}</h6>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <ul className="features">
            {features.map((feature, i) => (
              <PricingTableFeature
                key={feature?.title || i}
                feature={feature}
              />
            ))}
          </ul>
        </div>
      </PricingTableFeaturesDIV>
    )
  }

export default PricingTableFeatures
